<template>
  <div class="login">
    Login页面
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      
    }
  },
  methods:{
    
  }

};

</script>

<style scoped>
  .login{
    position: relative;
    bottom: 0;
    width: 100%;
    height: 150px;
    border: 1px #fff solid;
    background-color: gold;
    color: #000;
    font-size: 25px;
  }
 
</style>


// WEBPACK FOOTER //
// src/components/Login.vue